import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const h = a((o, l) => /* @__PURE__ */ e.jsx(
  i,
  {
    ref: l,
    ...o,
    image: (r) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...r,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zm-21.912-4.84h2.596V20h1.834v-6.855h2.595v-1.547H8.954zm11.356-1.547h-2.55L14.96 20h1.91l.627-2.016h3L21.118 20h1.94zm-1.301 1.529 1.031 3.369h-2.08z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
h.displayName = "TranexAcidIcon";
export {
  h as TranexAcidIcon,
  h as default
};
//# sourceMappingURL=index.js.map
